/** 活动角标位置(其他浮动图标需要用到：爆蛋、幸运红包) */
export const ACTIVITY_CORNER_POSITION = {
  TOP: 0.7,
  RIGHT: 14,
  HEIGHT: 68
} as const
